export default __webpack_public_path__ + "static/media/logo-us-FAO-Schwartz.7f78c46b.svg";